import { VisibilityState } from '@tanstack/table-core';

import {
  rendementsColStates,
  surfacesColStates,
  tonnagesColStates,
} from './col-states';

export enum LotsColumnPreset {
  Tonnages = 'tonnages',
  Surfaces = 'surfaces',
  Rendements = 'rendements',
}

type ColVisibilityState = Record<string, boolean>;

export const presetColStates: Record<LotsColumnPreset, ColVisibilityState> = {
  [LotsColumnPreset.Tonnages]: tonnagesColStates,
  [LotsColumnPreset.Surfaces]: surfacesColStates,
  [LotsColumnPreset.Rendements]: rendementsColStates,
};

export function getPresetColumnVisibility(
  preset: LotsColumnPreset,
): VisibilityState {
  return presetColStates[preset] as VisibilityState;
}
